import React, { Component } from 'react'

// Components
import Modal from '../../modal/Modal'
import Button from '../../modal/Button'

class AltButtons extends Component {
    constructor(props){
        super(props)
        this.state = {
            showModal: false,
            alt: props.alt
        }
        // console.log(props)
    }

    handleClick(e){
        e.stopPropagation()
        this.setState({ showModal: true }, () => {
            this.inputFocused.focus()
        })
    }

    closeAction(e){
        e.stopPropagation()
        this.setState({ showModal: false })
        this.props.closeAction(this.state.alt, this.props.index, this.props.assetIndex)
    }

    handleKeyPress(e){
        if(e.key === 'Enter'){
            this.closeAction(e)
        }
    }

    handleInputChange(e){
        this.setState({ alt: e.target.value })
    }

    render() {
        const { alt } = this.state

        return (
            <div className="toolbar-item" onClick={e => this.handleClick(e)}>
                <span>Alt</span>
                {this.state.showModal &&
                    <Modal title={'Update Image Alt Tag'} buttons={[
                        {
                            type: Button,
                            text: 'Ok',
                            action: this.closeAction.bind(this)
                        }
                    ]}>
                        <label>Alt Text</label>
                        <input type="text" value={alt} placeholder="Image alt text"
                            ref={(input) => { this.inputFocused = input }}
                            onKeyPress={e => this.handleKeyPress(e)}
                            onChange={this.handleInputChange.bind(this)}
                        />
                    </Modal>
                }
            </div>
        )
    }
}

export default AltButtons


// WEBPACK FOOTER //
// ./src/components/utils/image-toolbar/AltButton.js